module.exports = __webpack_public_path__ + "static/media/RangelyOneBedFloorPlan.bea80a8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Floorplans/RangelyOneBedFloorPlan.jpg
// module id = 306
// module chunks = 0